import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { InfoService } from '@services/info.service';
import { GameName } from '@services/lobby.service';
import { ResultService } from '@services/result.service';

export interface InfoBackEvent {
  autoOpen: boolean;
}

@Component({
    selector: 'inka-info',
    templateUrl: './info.component.html',
    styleUrls: ['./info.component.scss'],
    standalone: false
})
export class InfoComponent implements OnInit, OnDestroy {
  @Input() id: GameName = 'main'

  @Input() list: number[] = []
  @Input() type: undefined | 'game' | 'goal';
  @Input() item: undefined | 'common' | 'rule' | 'instruction';
  @Input() option: boolean = false;

  @Output() onClose: EventEmitter<void> = new EventEmitter<void>();
  @Output() onBack: EventEmitter<InfoBackEvent> = new EventEmitter<InfoBackEvent>();

  dontShowOrigin: boolean = false;
  dontShow: boolean = false;
  autoOpen: boolean = false;

  constructor(
    private result: ResultService,
    public info: InfoService) {
  }

  ngOnInit(): void {
    this.getStatus(this.id)
    if (this.dontShow || this.info.isContinue(this.id)) {
      return;
    }
    this.autoOpen = true;
    this.show();
  }

  ngOnDestroy() {
    this.hide();
  }

  getStatus(id: GameName) {
    const status = this.info.getStatus(id);
    this.dontShowOrigin = this.dontShow = status.dontShow;
  }

  setStatus() {
    const { id, dontShow } = this;
    localStorage.setItem(id, JSON.stringify({ dontShow }));
    this.dontShowOrigin = this.dontShow;
  }

  show() {
    this.info.visible$.next(true);
  }

  hide() {
    this.autoOpen = false;
    this.info.visible$.next(false);
  }

  back() {
    const event = { autoOpen: this.autoOpen };
    this.hide();
    this.onBack.emit(event);
    this.dontShow = this.dontShowOrigin;
  }

  next() {
    this.setStatus();
    this.hide();
    this.onClose.emit();
  }
}
